import { Plugin } from 'prosemirror-state';
import { uiStatePluginKey } from './keys';

export default () => {
  return new Plugin({
    key: uiStatePluginKey,
    state: {
      init() {
        return { showDiff: false, readOnly: false, historyMode: false };
      },
      apply(tr, prev) {
        const meta = tr.getMeta(uiStatePluginKey);

        if (typeof meta === 'undefined') return prev;
        const readOnly = meta.readOnly || false;
        const showDiff = meta.showDiff || false;
        const historyMode = meta.historyMode || false;

        return { readOnly: readOnly, showDiff: showDiff, historyMode: historyMode };
      }
    }
  });
};



// WEBPACK FOOTER //
// ./app/javascript/client/editor-core/plugins/UIStatePlugin.js